import React, { useContext, useEffect, useRef } from 'react'

import OnTheLineModules from '@toasttab/otl/src/components/PageModules/OnTheLineModules/OnTheLineModules'
import ArticleFeedback from '@toasttab/otl/src/components/Article/ArticleFeedback'
import Disclaimer from '@toasttab/onTheLine/src/components/PageModules/Disclaimer'
import StickyMelCTA from '@toasttab/onTheLine/src/components/MDS/CTA/StickyMelCTA'
import MelCTA from '@toasttab/otl/src/components/MDS/CTA/MelCTA'
import PromoCTA from '@toasttab/otl/src/components/MDS/CTA/PromoCTA'
import { OTLContext } from '@toasttab/shared/src/context/OTLContext'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'

const Article = ({ entry, formCategories }: any) => {
  const { region } = useI18next()
  const onTheLineModules = entry.content
  const formCategory = formCategories.filter(
    (n: { internalName: string }) => n.internalName === `[${region}] Email Only`
  )[0]
  const otlParams = useContext(OTLContext)
  const isMinimal = otlParams.isMinimal
  const ref = useRef<any | null>(null)

  useEffect(() => {
    const getAllContentLinks: any = ref.current.getElementsByTagName(`a`)
    const contentLinks = Array.from(getAllContentLinks)
    contentLinks.forEach((cL: any) => {
      cL.setAttribute('target', '_blank')
    })
  }, [])

  const hero = entry.hero
  return (
    <section className='ds-wrapper md:mt-10 md:mb-10 lg:mb-16 border-b border-gray-0'>
      <div className='ds-wrapper md:w-[776px] pb-10'>
        {Boolean(hero.ctas) &&
          Boolean(hero.ctas.length) &&
          Boolean(isMinimal) &&
          hero.ctas[0].__typename === 'gatedCtaLongForm' && (
            <StickyMelCTA melCTA={hero.ctas[0]} />
          )}
        {Boolean(hero.ctas) &&
          Boolean(hero.ctas.length) &&
          hero.ctas[0].__typename === 'ContentfulGatedCtaLongForm' && (
            <div className={isMinimal ? 'hidden md:inline' : 'inline'}>
              <MelCTA melCTA={hero.ctas[0]} />
            </div>
          )}

        {Boolean(hero.ctas) &&
          Boolean(hero.ctas.length) &&
          hero.ctas[0].__typename === 'ContentfulPromoBlock' && (
            <PromoCTA promoBlock={hero.ctas[0]} />
          )}
        <div
          className='max-w-otl-container mx-auto px-5 md:px-8 lg:px-0'
          ref={ref}
        >
          <OnTheLineModules
            entryId={entry.remoteId}
            formCategory={formCategory}
            onTheLineModules={onTheLineModules}
            displayOnSideBar={false}
            isPreview={otlParams.isPreview}
          />
          <ArticleFeedback slug={entry.slug} />
          {entry.showDisclaimer && <Disclaimer />}
        </div>
      </div>
    </section>
  )
}

export default Article
